export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const app = useAppStore()

  router.beforeEach(async (to, from) => {
    if (router.currentRoute.value.path === '/auth/') {
      return
    }
    if (app.user?.UM_IDX) {
      try {
        const { DropsMain } = await import('~/apis/point')
        if (app.user) {
          const response = await DropsMain({
            UM_IDX: app.user.UM_IDX,
          })

          if (response.data?.code === '200') {
            app.user.POINT = response.data.data.UM_POINT || 0
          }
        }
      } catch (error) {
        console.error('포인트 업데이트 실패:', error)
      }
    }
  })
})
